export default __webpack_public_path__ + "static/media/img-0326-botswana-full-face.9c188973.png";